/* Simple Bundles "Infinite Options" as Kkumi option cards
   (snippets/kkumi-sb-options.liquid).

   The cards are what the shopper uses; the Simple Bundles app block's own
   <select>s (hidden) stay the data layer. On every pick this:
   1. sets the app's select for that option and fires `change`, so the app's
      own script (io.min.js) writes the cart-line properties its checkout
      expansion reads;
   2. writes the same hidden inputs into THIS hero's product form —
      `properties[<option>]` per option plus `properties[_bundle_selection]`
      (values in the app's option order, " ++ " between options of one v2
      group, " <> " after a group), class `simple-bundles-infinite-option-prop`
      like the app's. The add then carries every choice even if the app's
      script hasn't run. Both writers produce the same values, and the app
      updates an input it finds rather than adding a second one.

   Stock is the app's: a value its select marks disabled (its "disable
   out-of-stock options" setting) becomes a sold-out card — muted, SOLD OUT
   tab, radio disabled so it can't be picked. If an option has nothing in
   stock, Add to cart is disabled with the sold-out label; a submit with an
   option missing or unavailable is stopped, the reason is announced and focus
   moves to that option.

   A bundle a sold-out REQUIRED component blocks (data-kk-sb-component-
   blocked, kkumi-bundle-blockers: no Strawberry Inner Sleeves) can't be
   bought at all. Its cards keep the stock the snippet rendered — each
   value's own component — instead of the app's (which counts the missing
   component too), Add to cart stays off, every add is stopped, and the
   hero's notice is the only message.

   The cards sit outside <variant-selects>, so a Deco Tweezers (variant)
   change neither re-renders nor resets them, and the hidden inputs live in the
   product form, which Dawn never replaces. Changing quantity touches neither. */
(function () {
  if (window.__kkSbOptions) return;
  window.__kkSbOptions = true;

  var PROP_CLASS = 'simple-bundles-infinite-option-prop';
  var SELECTION = 'properties[_bundle_selection]';

  function fill(tpl, name) {
    return String(tpl || '').replace(/\[option\]/g, name);
  }

  function titleOf(value) {
    var t = String(value || '').split('(')[0].trim();
    return t || String(value || '');
  }

  function bind(root) {
    if (root.__kkSbBound) return;
    root.__kkSbBound = true;

    var cfg = {};
    try {
      cfg = JSON.parse(root.querySelector('[data-kk-sb-config]').textContent) || {};
    } catch (e) { cfg = {}; }
    var names = Array.isArray(cfg.names) ? cfg.names : [];
    // The hero on the PDP; any `data-kk-sb-scope` wrapper elsewhere (Pick a
    // Kit's flavour panel), so nothing here reaches into another section.
    var hero = root.closest('[data-kk-sb-scope], product-info') || document;
    var scoped = !!root.closest('[data-kk-sb-scope]');
    var status = root.querySelector('[data-kk-sb-status]');
    var componentBlocked = root.hasAttribute('data-kk-sb-component-blocked');

    var variants = [];
    try { variants = JSON.parse(hero.getAttribute('data-kk-variants') || '[]'); } catch (e) { variants = []; }

    function form() {
      return document.getElementById(root.dataset.kkSbForm);
    }

    // Every app option in the app's order: a fieldset of cards, or a hidden
    // input for an option with one value.
    function entries() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-kk-sb-entry]'))
        .map(function (el) {
          var fixed = el.hasAttribute('data-kk-sb-fixed');
          var checked = fixed ? null : el.querySelector('[data-kk-sb-input]:checked');
          return {
            el: el,
            fixed: fixed,
            index: parseInt(el.dataset.kkSbIndex, 10) || 0,
            name: el.dataset.kkSbName || '',
            label: el.dataset.kkSbLabel || el.dataset.kkSbName || '',
            value: fixed ? el.value : (checked ? checked.value : ''),
            input: checked
          };
        })
        .sort(function (a, b) { return a.index - b.index; });
    }

    function appSelects() {
      // Off the PDP there is no app block for this product.
      if (scoped) return [];
      var box = document.getElementById('simple-bundles-io-options');
      return box ? Array.prototype.slice.call(box.querySelectorAll('select')) : [];
    }

    // The app's select for an option: by property name, else by position when
    // the app rendered exactly one select per option.
    function appSelectFor(entry, selects) {
      var want = 'properties[' + entry.name + ']';
      for (var i = 0; i < selects.length; i++) {
        if (selects[i].name === want) return selects[i];
      }
      return selects.length === names.length ? selects[entry.index] || null : null;
    }

    // The app's <option> for a card value. Exact first; then ignoring the
    // spaces around it, since the cards trim every value (the metafield is
    // comma-joined with or without a space, see kkumi-sb-options.liquid).
    function appOption(select, value) {
      var want = String(value == null ? '' : value);
      var trimmed = want.trim();
      var loose = null;
      for (var i = 0; i < select.options.length; i++) {
        var v = select.options[i].value;
        if (v === want) return select.options[i];
        if (!loose && trimmed && v.trim() === trimmed) loose = select.options[i];
      }
      return loose;
    }

    // Separator after each option — the app's own rule (io.min.js).
    function separators() {
      var seps = [];
      if (!Array.isArray(cfg.v2)) return seps;
      cfg.v2.forEach(function (group) {
        if (!Array.isArray(group)) return;
        group.forEach(function (opt, n) {
          seps.push(group.length > 1 && n !== group.length - 1 ? ' ++ ' : ' <> ');
        });
      });
      return seps;
    }

    function writeInput(f, name, value) {
      var input = null;
      var found = f.querySelectorAll('input.' + PROP_CLASS);
      for (var i = 0; i < found.length; i++) {
        if (found[i].name === name) { input = found[i]; break; }
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.className = PROP_CLASS;
        input.name = name;
        f.appendChild(input);
      }
      if (input.value !== value) input.value = value;
    }

    function sync() {
      var list = entries();
      var selects = appSelects();
      var f = form();
      var seps = separators();
      var parts = [];
      if (selects.length && selects.length !== list.length && window.console) {
        console.warn('[kk-sb] app block has ' + selects.length + ' selects for ' + list.length + ' options');
      }
      var values = [];
      list.forEach(function (e, i) {
        var sel = appSelectFor(e, selects);
        var opt = sel && e.value ? appOption(sel, e.value) : null;
        // Post exactly what the app's own select holds for this value, so
        // both writers of these inputs agree.
        var value = opt ? opt.value : e.value;
        if (opt && sel.value !== opt.value) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (f) writeInput(f, sel && sel.name ? sel.name : 'properties[' + e.name + ']', value);
        if (i) parts.push(seps[i - 1] || ' <> ');
        parts.push(value);
        values.push(value);
      });
      if (f && list.length) writeInput(f, SELECTION, parts.join(''));
      syncHearts(list, values, propertyKeys(list, selects), parts.join(''));
    }

    // The property name each option rides under (the app's select name when
    // there is one), so the heart saves exactly what the cart would receive.
    function propertyKeys(list, selects) {
      return list.map(function (e) {
        var sel = appSelectFor(e, selects);
        var name = sel && sel.name ? sel.name : 'properties[' + e.name + ']';
        var m = /^properties\[(.*)\]$/.exec(name);
        return m ? m[1] : e.name;
      });
    }

    // The wishlist heart(s) in this hero save the bundle WITH its choices
    // (kkumi-wishlist.js reads data-kk-wish-properties), so adding it back
    // from the wishlist restores the bundle instead of a bare parent.
    function syncHearts(list, values, keys, selection) {
      var props = {};
      var complete = true;
      list.forEach(function (e, i) {
        if (!values[i]) complete = false;
        props[keys[i]] = values[i];
      });
      props._bundle_selection = selection;
      var json = complete ? JSON.stringify(props) : '';
      hero.querySelectorAll('.kkumi-card__wish').forEach(function (btn) {
        if (json) {
          if (btn.getAttribute('data-kk-wish-properties') !== json) btn.setAttribute('data-kk-wish-properties', json);
        } else if (btn.hasAttribute('data-kk-wish-properties')) {
          btn.removeAttribute('data-kk-wish-properties');
        }
      });
    }

    function setLabel(group, input) {
      var label = group && group.querySelector('[data-kk-sb-selected]');
      var text = titleOf(input && input.value);
      if (label && label.textContent !== text) label.textContent = text;
    }

    function setSoldOut(input, out) {
      if (input.disabled === out && input.hasAttribute('data-kk-sb-soldout') === out) return;
      input.disabled = out;
      if (out) input.setAttribute('data-kk-sb-soldout', '');
      else input.removeAttribute('data-kk-sb-soldout');
      var card = input.closest('.var-option');
      if (!card) return;
      card.classList.toggle('var-option--soldout', out);
      var badge = card.querySelector('[data-kk-sb-badge]');
      var sr = card.querySelector('.label-unavailable');
      if (out && !badge) {
        badge = document.createElement('span');
        badge.className = 'var-option__badge';
        badge.setAttribute('data-kk-sb-badge', '');
        badge.textContent = root.dataset.kkSbSoldoutLabel || 'Sold out';
        card.appendChild(badge);
        if (!sr) {
          sr = document.createElement('span');
          sr.className = 'visually-hidden label-unavailable';
          sr.textContent = root.dataset.kkSbUnavailableLabel || '';
          card.appendChild(sr);
        }
      } else if (!out) {
        if (badge) badge.remove();
        if (sr) sr.remove();
      }
    }

    // Sold-out state from the app block: a value its select disables, or (when
    // matched by name) doesn't list at all, can't be bought.
    function mirrorStock() {
      var selects = appSelects();
      if (!selects.length) return;
      entries().forEach(function (e) {
        var sel = appSelectFor(e, selects);
        if (!sel) return;
        var byName = sel.name === 'properties[' + e.name + ']';
        // Blocked by a required component: the cards show their own stock.
        if (componentBlocked && !e.fixed) return;
        if (e.fixed) {
          var only = appOption(sel, e.value);
          var gone = only ? only.disabled : byName;
          if (gone) e.el.setAttribute('data-kk-sb-soldout', '');
          else e.el.removeAttribute('data-kk-sb-soldout');
          return;
        }
        e.el.querySelectorAll('[data-kk-sb-input]').forEach(function (input) {
          var opt = appOption(sel, input.value);
          // A backordered required component can make the app report zero
          // for every combination. Only live, in-stock source choices override it.
          if (input.hasAttribute('data-kk-sb-source-in-stock') && opt) return;
          setSoldOut(input, opt ? opt.disabled : byName);
        });
      });
    }

    // A pre-selected card that turned out sold out moves to the first card in
    // stock, the way the variant bundle opened on its first available combination.
    function ensureChoice() {
      entries().forEach(function (e) {
        if (e.fixed || (e.input && !e.input.disabled)) return;
        // An option set to start blank (the hero's option rows) stays empty
        // until the shopper picks; never fill it in for them.
        if (!e.input && e.el.hasAttribute('data-kk-blank-start')) return;
        var first = e.el.querySelector('[data-kk-sb-input]:not(:disabled)');
        if (!first) return;
        first.checked = true;
        setLabel(e.el, first);
      });
    }

    function problem() {
      var list = entries();
      if (componentBlocked) return { entry: list[0] || null, kind: 'component' };
      for (var i = 0; i < list.length; i++) {
        var e = list[i];
        if (e.fixed) {
          if (!e.value) return { entry: e, kind: 'choose' };
          if (e.el.hasAttribute('data-kk-sb-soldout')) return { entry: e, kind: 'soldout' };
          continue;
        }
        if (e.input && !e.input.disabled) continue;
        var open = e.el.querySelector('[data-kk-sb-input]:not(:disabled)');
        return { entry: e, kind: open ? 'choose' : 'soldout' };
      }
      return null;
    }

    function selectedVariant() {
      var f = form();
      var idInput = f && f.querySelector('input[name="id"]');
      if (!idInput) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idInput.value)) return variants[i];
      }
      return null;
    }

    // Add to cart follows the app's stock too: disabled with the sold-out label
    // while an option has nothing in stock, restored (to whatever the selected
    // variant allows) once it does. Only undoes what it did itself.
    function syncAtc(p) {
      var atc = hero.querySelector('.kk-pdp-atc-btn');
      if (!atc) return;
      var label = atc.querySelector('span');
      var blocked = !!(p && (p.kind === 'soldout' || p.kind === 'component'));
      if (blocked) {
        root.dataset.kkSbBlocked = '1';
        atc.setAttribute('disabled', 'disabled');
        var soldOut = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
        if (label && label.textContent !== soldOut) label.textContent = soldOut;
      } else if (root.dataset.kkSbBlocked) {
        delete root.dataset.kkSbBlocked;
        var v = selectedVariant();
        if ((!v || v.available) && !(hero.closest && hero.closest('[data-kk-blocked]'))) {
          atc.removeAttribute('disabled');
          var ready = atc.dataset.availableLabel || (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
          if (label && label.textContent !== ready) label.textContent = ready;
        }
      }
    }

    function applyState(announce) {
      var p = problem();
      syncAtc(p);
      // The hero's notice names the missing component; no second message.
      if (p && p.kind === 'component') p = null;
      entries().forEach(function (e) {
        if (e.fixed) return;
        var bad = !!(p && p.entry.el === e.el && (announce || p.kind === 'soldout'));
        if (bad) e.el.setAttribute('aria-invalid', 'true');
        else e.el.removeAttribute('aria-invalid');
      });
      if (!status) return;
      var msg = '';
      if (p && (announce || p.kind === 'soldout')) {
        msg = fill(p.kind === 'soldout' ? root.dataset.kkSbSoldout : root.dataset.kkSbChoose, p.entry.label);
      }
      if (status.textContent !== msg) status.textContent = msg;
      status.hidden = !msg;
    }

    function hideAppRow() {
      var box = document.getElementById('simple-bundles-io-options');
      var row = box && box.closest('[data-kk-app-block]');
      if (row && hero.contains(row) && row.style.display !== 'none') row.style.display = 'none';
    }

    function refresh() {
      hideAppRow();
      mirrorStock();
      ensureChoice();
      sync();
      applyState(false);
    }

    root.addEventListener('change', function (evt) {
      var input = evt.target;
      if (!input || !input.matches || !input.matches('[data-kk-sb-input]')) return;
      setLabel(input.closest('[data-kk-sb-entry]'), input);
      sync();
      applyState(false);
    });

    // Validation. The add itself is global.js's capture-phase `submit`
    // listener on document, which stops every later listener there — so this
    // one sits on WINDOW (capture runs window → document) and a blocked add
    // never reaches /cart/add.js.
    window.addEventListener('submit', function (evt) {
      var f = form();
      if (!f || evt.target !== f) return;
      sync();
      var p = problem();
      if (!p) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (p.kind === 'component') return;
      applyState(true);
      // Collapsed option rows (kkumi-pdp-option-rows.js) open the row first,
      // so the focus below lands on a visible card.
      p.entry.el.dispatchEvent(new CustomEvent('kk:reveal-option', { bubbles: true }));
      var target = p.entry.el.querySelector('[data-kk-sb-input]:not(:disabled)') ||
        p.entry.el.querySelector('[data-kk-sb-input]');
      if (p.entry.el.scrollIntoView) p.entry.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (target) target.focus({ preventScroll: true });
    }, true);

    // The hero re-applies Add to cart on every variant change (its own timer,
    // then Dawn's variantChange). Re-apply the app's stock rule after both.
    function later() {
      setTimeout(function () { setTimeout(function () { sync(); applyState(false); }, 0); }, 0);
    }
    hero.addEventListener('change', function (evt) {
      if (evt.target && evt.target.closest && evt.target.closest('variant-selects')) later();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, later);
    }

    refresh();
    // The app's script is deferred like this one; run once more after it.
    if (document.readyState !== 'complete') window.addEventListener('load', refresh, { once: true });
  }

  function init() {
    document.querySelectorAll('[data-kk-sb]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
